import { BreadcrumbComponent } from "./breadcrumb/breadcrumb.component";
import { CommunicationAddressFormComponent } from "./communication-address-form/communication-address-form.component";
import { CommunicationAddressEmailFormComponent } from "./communication-address-email-form/communication-address-email-form.component";
import { CommunicationAddressPhoneFormComponent } from "./communication-address-phone-form/communication-address-phone-form.component";
import { SideNavigationItemComponent } from "./side-navigation-item/side-navigation-item.component";
import { ChartRendererComponent } from "./chart-renderer/chart-renderer.component";
import { UsersPerFrequencyChartComponent } from "./users-per-frequency-chart/users-per-frequency-chart.component";
import { UsersSummaryChartComponent } from "./users-summary-chart/users-summary-chart.component";
import { ChartRendererNumberComponent } from "./chart-renderer-number/chart-renderer-number.component";

export const components: any[] = [
  SideNavigationItemComponent,
  BreadcrumbComponent,
  CommunicationAddressFormComponent,
  CommunicationAddressEmailFormComponent,
  CommunicationAddressPhoneFormComponent,
  ChartRendererComponent,
  UsersPerFrequencyChartComponent,
  UsersSummaryChartComponent,
  ChartRendererNumberComponent,
];

export * from "./side-navigation-item/side-navigation-item.component";
export * from "./breadcrumb/breadcrumb.component";
export * from "./communication-address-form/communication-address-form.component";
export * from "./communication-address-email-form/communication-address-email-form.component";
export * from "./communication-address-phone-form/communication-address-phone-form.component";
export * from "./chart-renderer/chart-renderer.component";
export * from "./users-per-frequency-chart/users-per-frequency-chart.component";
export * from "./users-summary-chart/users-summary-chart.component";
export * from "./chart-renderer-number/chart-renderer-number.component";
